<!--新增分摊项目-->
<template>
	<div>
		<el-dialog :title="title" :visible.sync="addTemplateShow">
			<el-form style="margin:0px;">
				<el-form-item label="分摊项目名称" :label-width="formLabelWidth" :required="nonEmpty">
					<el-input v-model="itemName" autocomplete="off" placeholder="请输入分摊项目名称" style="width:95%;"></el-input>
				</el-form-item>
				<div style="display: flex; justify-content:center; margin:0px; padding:0px; width:100%;">
					<div style="margin-left:10px;margin-right:10px;margin-top:0px; margin-bottom:0px;">
						<div style="font-size:18px;">内机</div>
						<elCheckBoxTree @checkItem="checkItemLeft" :dataList='virtualDeviceList' style="width:300px; height:400px;"></elCheckBoxTree>
					</div>
					<div style="margin-left:10px;margin-right:10px;margin-top:0px; margin-bottom:0px;">
						<div style="font-size:18px;">外机</div>
						<elCheckBoxTree @checkItem="checkItemRight" :dataList='virtualDeviceList' style="width:300px; height:400px;"></elCheckBoxTree>
					</div>
				</div>
			</el-form>
			<div slot="footer" class="dialog-footer" style="margin-top:0px;">
				<el-button @click="addTemplateShow = false">取 消</el-button>
				<el-button type="primary" @click="confirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import elCheckBoxTree from './elCheckBoxTree.vue'
	export default {
		components: {
			elCheckBoxTree,
		},
		props: {
		},
		data() {
			return {
				itemId: '',
				itemName: '',
				formLabelWidth: '130px',
				addTemplateShow: false,
				title: '增加空调内外机关联',
				selectDeviceListLeft: [], //选中的设备
				selectDeviceListRight: [], //选中的设备
				isEdit: true, //是否为编辑
				nonEmpty:true,//显示红星
				leftDefaultDevices:[],
			}
		},
		created() {
		},
		mounted() {
		},
		destroyed() {},
		computed: {
			virtualDeviceList() {
				var data = this.$store.deviceStore.getters.getReadDeviceTree
				return isempty(data) ? [] : [deviceList(data)]
			},
			ldds(){
				return [19];
			}
		},
		watch: {
		},
		methods: {
			setLeftDefualtDevices(dds){
				
			},
			checkItemLeft(list) {
				this.selectDeviceListLeft = list
			},
			checkItemRight(list) {
				this.selectDeviceListRight = list
			},
			confirm() {
				if(this.itemName.length == 0){
					this.$message.error('请输入分摊项目名称');
					return;
				}
				var deviceNoLeft = [];
				for(var i=0; i<this.selectDeviceListLeft.length; i++){
					deviceNoLeft[deviceNoLeft.length] = this.selectDeviceListLeft[i].no;
				}
				var deviceNoRight = [];
				for(var i=0; i<this.selectDeviceListRight.length; i++){
					deviceNoRight[deviceNoRight.length] = this.selectDeviceListRight[i].no;
				}
				if(isempty(deviceNoLeft) || isempty(deviceNoRight)) {
					this.$message.error('请选择设备');
					return
				}
				this.$api.tcFentanApi.addDivideItem(
					this.itemId,
					this.itemName,
					1,
					deviceNoLeft,
					deviceNoRight,
					respon => {
						this.$message.success('新增分摊项目成功');
						this.$emit('addItemSuccess');
						this.addTemplateShow = false;
					}, failure => {
						this.$message({
							type: 'error',
							message: failure
						});
					}
				)
			},
		}
	}
</script>

<style>
	.addNewOwnerDialogBody {
		/*width: 100%;
		 height: 100%;*/
	}
	
	.addNewOwnerDialogBody .dialog-from {
		width: calc(100% - 3.3rem);
		height: 100%;
	}
	
	.dialog-device {
		height: 710px;
		margin-left: 40px;
	}
	
	.addNewOwnerDialogBody .el-dialog__body {
		display: flex;
		align-items: center;
		padding: 0;
	}
</style>